import { monthKey } from '../../../utils/dateUtils.js'

export function calcularHaberDocente(expediente = {}, rulesConfig = {}, rows = []) {
  const docenteCfg = rulesConfig?.regimenDocente || {}
  const datosDocentes = expediente?.datosDocentes || {}
  const porcentaje = Number(docenteCfg?.porcentajeSustitucion || 0.82)
  const minContinuos = Number(docenteCfg?.minimoMesesContinuosCargo || 60)
  const minAlternados = Number(docenteCfg?.minimoMesesAlternadosCargo || 120)

  const cargoCese = String(datosDocentes?.cargoCese || '').trim()
  const mesesContinuos = Number(datosDocentes?.mesesEnCargoContinuos || 0)
  const mesesAlternados = Number(datosDocentes?.mesesEnCargoAlternados || 0)
  const sueldoBrutoCargoCese = Number(datosDocentes?.sueldoBrutoCargoCese || 0)

  // Auto-detect base from fused rows at cese month
  // Busca en las filas consolidadas (post-fusion multi-CUIT) el mes de cese
  // y usa ese monto como base del 82%. Si no encuentra, cae a sueldoBrutoCargoCese.
  let baseDetected = null
  if (Array.isArray(rows) && rows.length > 0 && expediente?.fechaCese) {
    const ceseKey = monthKey(expediente.fechaCese)
    if (ceseKey) {
      const ceseRows = rows.filter(
        (r) => monthKey(r.periodoKey || r.periodo || r.periodoISO) === ceseKey && (Number(r.monto) || 0) > 0,
      )
      if (ceseRows.length > 0) {
        baseDetected = ceseRows.reduce((sum, r) => sum + Number(r.monto), 0)
      }
    }
  }
  const baseEfectiva = baseDetected !== null ? baseDetected : sueldoBrutoCargoCese

  const cumpleContinuos = mesesContinuos >= minContinuos
  const cumpleAlternados = mesesAlternados >= minAlternados
  const derechoCausado = Boolean(baseEfectiva > 0 && (cumpleContinuos || cumpleAlternados))

  if (!derechoCausado) {
    return {
      derechoCausado: false,
      regimenAplicado: 'DECRETO_137_05',
      alerta: 'No cumple requisitos de cargo docente (60 continuos o 120 alternados) o falta sueldo bruto del cargo al cese.',
      componentesHaber: {
        remuneracionReferencia: 0,
        haberInicialSustitutivo: 0,
        pbu: 0,
        pc: 0,
        pap: 0,
      },
      exentoTopeArt9: true,
      exentoTopeMaximoHaber: true,
      doctrinaSugerida: String(docenteCfg?.doctrinaExencionTopes || 'Gemelli c/ ANSES'),
    }
  }

  const haberInicialDocente = baseEfectiva * porcentaje
  return {
    derechoCausado: true,
    regimenAplicado: 'DECRETO_137_05',
    cargoCese,
    baseDetectadaEnFilas: baseDetected !== null,
    componentesHaber: {
      remuneracionReferencia: Number(baseEfectiva.toFixed(2)),
      haberInicialSustitutivo: Number(haberInicialDocente.toFixed(2)),
      pbu: 0,
      pc: 0,
      pap: 0,
    },
    exentoTopeArt9: true,
    exentoTopeMaximoHaber: true,
    doctrinaSugerida: String(docenteCfg?.doctrinaExencionTopes || 'Gemelli c/ ANSES'),
  }
}
